export enum TrackLogType {
  BANNER         = 1,  // banner 图
  GROWING_PLAN   = 2,//成长计划
  COUORSE        = 3,//课程
  VIP_CARD       = 4,//查看卡详情
  CLICK_BUY_CARD = 5,//获取会员卡信息
  BUY_IT         = 6,//点击了购买
  SELECT_CARD    = 7,//选择某个卡
  START_LEARNING = 8,//开始学习
}